module.exports = __webpack_public_path__ + "static/katherine_rundell-840f6023a28e639af6dab474dc384a74.jpg";